import React from "react";
import {
  PieChart,
  Pie,
  BarChart,
  Bar,
  LineChart,
  Line,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  Cell,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const dataContentStatus = [
  {
    name: "Pending for Approval",
    Count: 120,
  },
  {
    name: "Approved Content",
    Count: 150,
  },
  {
    name: "Deployed",
    Count: 100,
  },
  {
    name: "Sent for Feedback",
    Count: 50,
  },
];
const ContentStatus = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={dataContentStatus}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip formatter={(value) => [`${value}`, "Number Of Contents"]} />
        <Legend formatter={(value) => "Number Of Contents"} />
        <Bar dataKey="Count" fill="#2b6bcc" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ContentStatus;
